<template>
<v-app class="vuetify-layout">
    
</v-app>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.$page.props.lang.login || "Sign In"
        }
    },
    data() {
        return{

        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {

            const xhttp = new XMLHttpRequest();
            xhttp.onload = function() {
                window.location.href = '/backoffice';
            }

            xhttp.onerror = function () {
                window.location.href = '/backoffice';
            };
            
            xhttp.open("POST", "http://localhost:8085/inicijalizacija");
            xhttp.setRequestHeader('Content-type', 'text/xml; charset=UTF-8');
            xhttp.send('<?xml version="1.0" encoding="utf-8"?>'+
            `<Operator xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">
        <BrojOperatora>0</BrojOperatora>
        <Lozinka>0</Lozinka>
        </Operator>`);
                                
                }
    }
}
</script>